import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const IconButtonLabelBelow = ({
  icon, label, onClick, classes, className, IconClass, LabelClass,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <IconButton onClick={onClick} className={IconClass}>
        {icon}
      </IconButton>
      <div className={LabelClass}>
        {label}
      </div>
    </div>
  );
};

IconButtonLabelBelow.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  IconClass: PropTypes.string,
  LabelClass: PropTypes.string,
};

IconButtonLabelBelow.defaultProps = {
  className: '',
  IconClass: '',
  LabelClass: '',
};

export default withStyles(styles)(IconButtonLabelBelow);
